import { html } from 'lit';
import { CheckCircle } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-check-circle')
export class PdsIconCheckCircle extends PdsIcon {
  @state()
  icon = CheckCircle;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
